// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3vxPM","inputWrap":"Table_inputWrap__3wu7i","col":"Table_col__9kd3M","bmiTooltip":"Table_bmiTooltip__2dMJp"};